(function () {
    'use strict';


    angular
        .module('createPairing')
        .controller('DeadheadTravelCtrl', DeadheadTravelCtrl);

    function DeadheadTravelCtrl($uibModalInstance, modalParams,CreatePairing, EventManagerService) {
        var vm = this;
        vm.ctrlName = 'deadheadTravel';
        vm.model = {
            responseList : modalParams.travelResponse,
            failedCount:0,
            detailedMessage:""
        }

          angular.forEach(vm.model.responseList, function (responce) {
              if(!responce.bookingSuccess){
                vm.model.failedCount++;
              }
          });


        vm.closeMe = function () {
            $uibModalInstance.close();
        }

        vm.onResubmitTravelRequest = function (patternId) {
          $uibModalInstance.close();
          EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING,true);
          var list = [];
          list.push(patternId);
          CreatePairing.sendDeadHeadResubmitRequest(list,
            function (response) {
              $uibModalInstance.close();
            },
            function (error) {
              MessageService.error(error);
            }
          );


        }

        vm.showFailDetails = function (message) {
          vm.model.detailedMessage = message;
        }


        vm.onOverrideTravelRequest = function (patternId) {
          var list = [];
          list.push(patternId);
          $uibModalInstance.close();
          CreatePairing.overrideTravelRequest(list,
            function (response) {
              $uibModalInstance.close();
            },
            function (error) {
              MessageService.error(error);
            }
          );
        }
    }
}());
